import { render, staticRenderFns } from "./FormInfo.vue?vue&type=template&id=1c8c39d6&scoped=true"
import script from "./FormInfo.vue?vue&type=script&lang=ts"
export * from "./FormInfo.vue?vue&type=script&lang=ts"
import style0 from "./FormInfo.vue?vue&type=style&index=0&id=1c8c39d6&prod&lang=scss&scoped=true"
import style1 from "./FormInfo.vue?vue&type=style&index=1&id=1c8c39d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8c39d6",
  null
  
)

export default component.exports